import React from 'react';
import styles from './LoadingSkeleton.module.css';

interface LoadingSkeletonProps {
  variant?: 'text' | 'rectangular' | 'circular';
  width?: string;
  height?: string;
  count?: number;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ 
  variant = 'text',
  width = '100%',
  height = variant === 'text' ? '1em' : '200px',
  count = 1
}) => {
  const skeletons = Array.from({ length: count }, (_, index) => (
    <div
      key={index}
      className={`${styles.skeleton} ${styles[variant]}`}
      style={{ width, height }}
    />
  ));

  return <>{skeletons}</>;
};

export default LoadingSkeleton;
